import { c as _c } from "react/compiler-runtime";
import CircleLoader from "@/components/distribution-plan-tool/common/CircleLoader";
import { RepSearchState } from "./rep-search-types";
export default function UserPageRepNewRepSearchDropdown(t0) {
  const $ = _c(12);
  const {
    categories,
    onRepSelect,
    state,
    minSearchLength,
    maxSearchLength
  } = t0;
  if (state === RepSearchState.MIN_LENGTH_ERROR) {
    let t1;
    if ($[0] !== minSearchLength) {
      t1 = <p className="tw-mb-0 tw-px-2 tw-py-1 tw-text-xs tw-font-normal tw-text-iron-500">Type at least {minSearchLength} characters</p>;
      $[0] = minSearchLength;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    return t1;
  }
  if (state === RepSearchState.MAX_LENGTH_ERROR) {
    let t1;
    if ($[2] !== maxSearchLength) {
      t1 = <p className="tw-mb-0 tw-px-2 tw-py-1 tw-text-xs tw-font-normal tw-text-iron-500">Type at most {maxSearchLength} characters</p>;
      $[2] = maxSearchLength;
      $[3] = t1;
    } else {
      t1 = $[3];
    }
    return t1;
  }
  if (state === RepSearchState.LOADING) {
    let t1;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <div className="tw-flex tw-items-center tw-gap-2 tw-px-2 tw-text-xs tw-text-iron-400"><CircleLoader /><span>Searching...</span></div>;
      $[4] = t1;
    } else {
      t1 = $[4];
    }
    return t1;
  }
  if (!categories.length) {
    return null;
  }
  let t1;
  if ($[5] !== categories || $[6] !== onRepSelect) {
    let t2;
    if ($[8] !== onRepSelect) {
      t2 = category => <button key={category} type="button" onClick={e => {
        e.stopPropagation();
        onRepSelect(category);
      }} className="tw-cursor-pointer tw-rounded-lg tw-border tw-border-solid tw-border-white/10 tw-bg-white/5 tw-px-3 tw-py-2 tw-text-sm tw-font-medium tw-text-white tw-transition tw-duration-200 tw-ease-out hover:tw-border-white/20 hover:tw-bg-white/10 md:tw-px-2 md:tw-py-1.5 md:tw-text-xs">{category}</button>;
      $[8] = onRepSelect;
      $[9] = t2;
    } else {
      t2 = $[9];
    }
    t1 = categories.map(t2);
    $[5] = categories;
    $[6] = onRepSelect;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  let t2;
  if ($[10] !== t1) {
    t2 = <div className="tw-flex tw-flex-wrap tw-gap-2.5 tw-px-1 tw-py-1">{t1}</div>;
    $[10] = t1;
    $[11] = t2;
  } else {
    t2 = $[11];
  }
  return t2;
}